<div class="columns-2" [ngBusy]=loading>
	<checkbox-button
		class="_t-customer-admin"
		label="{{'administration.customerAdmin'|i18n}}" 
		[disabled]="isCustomerAdminDisabled()"
		[tooltipText]="getCustomerAdminTooltip()"
		[(ngModel)]="user.customerAdmin"
		(ngModelChange)="changeHandler()">
	</checkbox-button>
</div>